import React from 'react';

const LessonFinancialFields = ({ value, onChange, total, onTotalChange, disabled = false, onPaymentBlur }) => <>
  {[
    ['purchases', 'Purchases total (includes sales tax):'],
    ['referralCredit', 'Referral Credit:'],
    ['fee', 'Lesson total:'],
    ['payment', 'Payment:'],
    ['paymentType', 'Payment Type:'],
    ['credit', 'Credit:']
  ].map(([field, label]) => <div key={field} style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '0.75rem' }}>
    <label htmlFor={`lesson-financial-${field}`}>{label}</label>
    {field === 'paymentType'
      ? <select id={`lesson-financial-${field}`} aria-label={label.slice(0, -1)} value={value[field] ?? ''} disabled={disabled} onChange={event => onChange(previous => ({ ...previous, [field]: event.target.value }))} style={{ width: '140px', flexShrink: 0 }}>
        <option value="">Select Type</option><option value="Cash">Cash</option><option value="Check">Check</option><option value="CC">CC</option>
      </select>
      : <input id={`lesson-financial-${field}`} aria-label={label.slice(0, -1)} type="number" step="0.01" value={field === 'fee' ? total : value[field] ?? ''} readOnly={disabled} onChange={event => {
        const next = event.target.value;
        if (field === 'fee') onTotalChange(next);
        onChange(previous => ({ ...previous, [field]: next }));
      }} onBlur={field === 'payment' ? onPaymentBlur : undefined} style={{ width: '140px', flexShrink: 0, boxSizing: 'border-box', backgroundColor: disabled ? '#f5f5f5' : 'white' }} />}
  </div>)}
</>;

export default LessonFinancialFields;